const manageUser = {
  manageUser: {
    pageTitle: '사용자 관리',
    description: '사용자별 역할, 권한, 그리고 이용 가능한 메뉴를 관리하고 맞춤 설정합니다.',
    tabs: {
      manageUsers: '사용자 관리',
      userPermission: '사용자 권한',
      menuVisibility: '메뉴 노출'
    },
    searchPlaceholder: '검색'
  }
};

export default manageUser;